import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import InsuranceDetail from "./pages/Insurance_Certificate/Detail";
import InsuranceCertificateIndex from "./pages/Insurance_Certificate/Index";
import Layout from "./Layout/Layout";
import HealthInsuranceCard from "./pages/Health_Insurance_Card/Index";
import Login from "./pages/Login/Login";
import OTP from "./pages/Login/Otp";
import DigitalLoginLoading from "./pages/Login/DigitalloginLoading";
import NotFound from "./pages/404";
import Profile from "./pages/Profile";
import ContactUs from "./pages/ContactUs/index";
import Registration from "./pages/Doctor_Appointment/index"
import MapsBranches from "./pages/Maps_branches";
import MyAppointment from "./pages/My_appointment/Index"
import { initializeActivityTracking, cleanupActivityTracking } from "./api/axiosConfig";

interface AppProps {
  children?: React.ReactNode;
}

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

const OTPRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const otpAllowed = sessionStorage.getItem("otpAllowed") === "true";

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!otpAllowed) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App({ children }: AppProps) {
  const location = useLocation();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

    if (isAuthenticated) {
      initializeActivityTracking();
    } else {
      cleanupActivityTracking();
    }

    return () => {
      cleanupActivityTracking();
    };
  }, [location.pathname]);

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/otp"
        element={
          <OTPRoute>
            <OTP />
          </OTPRoute>
        }
      />

      <Route
        path="/mygovid/login"
        element={
          <PublicRoute>
            <DigitalLoginLoading />
          </PublicRoute>
        }
      />

      <Route
        path="/myprofile"
        element={
          <ProtectedRoute>
            <Layout>
              <Profile />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <InsuranceCertificateIndex />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/health-insurance-card"
        element={
          <ProtectedRoute>
            <Layout>
              <HealthInsuranceCard />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/contact-us"
        element={
          <ProtectedRoute>
            <Layout>
              <ContactUs />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/medicalrequests"
        element={
          <ProtectedRoute>
            <Layout>
              <MyAppointment />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/insurance-detail/:poli3cyNumber"
        element={
          <ProtectedRoute>
            <Layout>
              <InsuranceDetail />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/branches"
        element={
          <ProtectedRoute>
            <Layout>
              <MapsBranches />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/doctor-appointment"
        element={
          <ProtectedRoute>
            <Layout>
              <Registration />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;